/**
 * Featured wrap on Spaces-tab tiles is independent of ranking/boost.
 * wrapAsFeatured false hides the wrap; missing flags stay backward compatible.
 */

const NESTED_PROMOTION_KEYS = ['hostPromotion', 'promotion', 'activeHostPromotion', 'activePromotion'];

const toOptionalBoolean = (value) => {
  if (typeof value === 'boolean') return value;
  return undefined;
};

export const resolveWrapAsFeatured = (space) => {
  if (!space || typeof space !== 'object') return undefined;

  const direct = toOptionalBoolean(space.wrapAsFeatured);
  if (direct !== undefined) return direct;

  for (let i = 0; i < NESTED_PROMOTION_KEYS.length; i += 1) {
    const nested = toOptionalBoolean(space[NESTED_PROMOTION_KEYS[i]]?.wrapAsFeatured);
    if (nested !== undefined) return nested;
  }

  return undefined;
};

/**
 * Whether the Spaces-tab tile should show the Featured wrap/banner.
 * Ranking/boost (promotionType and list order) must not be used as the wrap signal.
 */
export const shouldWrapAsFeatured = (space) => {
  const wrapAsFeatured = resolveWrapAsFeatured(space);
  if (wrapAsFeatured === false) return false;
  if (wrapAsFeatured === true) return true;
  // Missing flag: keep today's wrap for any space that already has an active promotion.
  return Boolean(space?.promotionType);
};
